import { trackGtmEvent } from './gtm-data-layer'

const gtmEvents = [
  'avantLinkPurchase',
  'gtmEvent',
  'gtmEcomPromotionView',
  'gtmEcomPromotionClick',
  'gtmEcomProductImpression',
  'gtmEcomProductClick',
  'gtmEcomDetailView',
  'gtmEcomAddToCart',
  'gtmEcomRemoveFromCart',
  'gtmEcomCheckout',
  'gtmEcomCheckoutOption',
  'gtmEcomPurchase',
  'gtmVirtPath',
  'rockerBoxCheckout',
  'rockerBoxPurchase',
]

const gtmEventServices = {}

gtmEvents.forEach(event => {
  gtmEventServices[event] = (event, eventPayload) => trackGtmEvent(event, eventPayload)
})

export default {
  ...gtmEventServices,
  // ...dyEvents,
  // ...etc.,
}
